export const caminhoAtual = (caminho) => {
  return{
    type: "CAMINHO_ATUAL",
    caminho
  }
}



// WEBPACK FOOTER //
// ./src/actions/CaminhoActions.js